<template>
  <div class="footer">
    <div class="arc" :style="setStyle('vice','backgroundColor')"></div>
    <div class="content" :style="setStyle('vice','backgroundColor')">
      <a class="footer_text" target="_blank" href="https://beian.miit.gov.cn/">{{editionText}}</a>
    </div>
  </div>
</template>
<script>
import { setColor } from '../../utils/style';
import { mapState } from 'vuex'
import {getPathNameUrl} from '@/utils/query-string.js'
export default {
  name: 'v-footer',
  props: {
    config: {
      type: Object,
      default: () => {},
    },
  },
   computed: {
    ...mapState({
        globalConfig: state => state.router.globalConfig,
    }),
    editionText(){
      let text = getPathNameUrl() && getPathNameUrl().includes('weilaicode') ? 
      '京ICP备09032638号-41\xa0\xa0\xa0\xa0\xa0\xa0京公网安备11010802033537号' :  '京ICP备09032638号-42';
      return text
    }
  },
  methods: {
    setStyle(key, type) {
      return setColor(this.globalConfig, key, type);
    },
  },
  mounted() {

  },
};
</script>
<style lang="less" scoped>
.footer{
  width: 100%;
  height: 210px;
  position: absolute;
  bottom:0;
  left:0;
  // position: fixed;
  overflow: hidden;
  // z-index: 2;
  .arc{
    width: 120%;
    height: 210px;
    margin-left:-10%;
    border-radius: 50%;
    // transform: translate(-50%,0);
  }
  .content{
    position: absolute;
    top:48px;
    left:0;
    width: 100%;
    height: 210px;
    text-align: center;
    .footer_text{
      display: inline-block;
      padding-top:114px;
      color:#333333;
      font-size: 14px;
    }
  }
}
</style>
